import React, { useContext } from 'react';

import LayoutProvider from '../../utils/styles/layout/LayoutProvider';
import layoutFactory from '../../utils/styles/layout/layoutFactory';
import styled, { withTheme, ThemeContext } from 'styled-components';
import useLayout from '../../utils/styles/layout/useLayout';

type ViewProps = {
  layout?: any;
  backgroundColor?: string;
};

const InnerView = styled.div<ViewProps>`
  background-color: ${props => props.backgroundColor};
`;

const View: React.SFC<ViewProps> = props => {
  const { colors } = useContext(ThemeContext);
  const layout = useLayout();
  const _layout = layoutFactory(props) || {};
  const backgroundColor = _layout.backgroundColor || layout.backgroundColor || colors.light.primary;
  const finalLayout = {
    ..._layout,
    backgroundColor
  };
  return (
    <LayoutProvider value={finalLayout}>
      <InnerView {...props} backgroundColor={finalLayout.backgroundColor}>
        {props.children}
      </InnerView>
    </LayoutProvider>
  );
};

export default View;
